import React, { useState } from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import CategoriesSection from '../../../components/store/reusable/category/CategoriesSection'
import { useParams, useSearchParams } from 'react-router-dom'
import { categoriesOwnerHomeType } from '../../../types/enum/categoriesOwnerHome'
import FirstSectionHeroLand from '../../../components/owner/FirstSectionHeroLand'
import SecondHeroSection from '../../../components/owner/SecondHeroSection'
import { useStoreFinancials, useStoreOrdersAnalytics, useStoreOrdersStatistics, useTopFourProductOrdered } from '../../../hooks/store/homeUi'
import TopFourProductsOrdered from '../../../components/owner/TopFourProductsOrdered'
import CircleProgress from '../../../components/ui/HalfCircleProgress'
import HalfCircleRed from '../../../components/ui/MultiHalfCircle'
import LoadingErrorState from '../../../components/ui/LoadingErrorState'
import StoreStatsSearchForm from '../../../components/owner/StoreStatsSearchForm'

export default function OwnerHomePage() {
      const { storeId} = useParams<{ storeId: string}>();
    const numericStoreId = storeId ? parseInt(storeId) : undefined;
    const {t} = useTranslation();
    const [searchParams,setSearchParams] = useSearchParams();
    const category = (searchParams.get("category")) ||""
    const dateFrom = (searchParams.get("dateFrom")) ||"";
    const dateTo = (searchParams.get("dateTo")) ||""
    const [categories] = useState([
      { id: "year", name: t(categoriesOwnerHomeType.THISYEAR) },
      { id: "month", name: t(categoriesOwnerHomeType.THISMONTH) },
      { id: "week", name: t(categoriesOwnerHomeType.THISWEEK) },
      { id: "today", name: t(categoriesOwnerHomeType.THISDAY) },
    ]);

// Handler for the "Custom" button click
//   const handleCustomClick = () => {
//     // Set the category to 'custom-date' which will trigger the date input to appear
//     setSearchParams(prevParams => {
//       prevParams.set('category', 'specific');
//       return prevParams;
//     });
//   };

//   // Handler for the date input change
//   const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>
// ) => {
//     const newDate = event.target.value;
//     // Update the URL query with the new date
//     setSearchParams(prevParams => {
//       if (newDate) {
//         prevParams.set('date', newDate);
//       } else {
//         prevParams.delete('date');
//       }
//       return prevParams;
//     });
//   };

  const {data:financials,isLoading:financialsLoading} = useStoreFinancials({filter:category,date:"",storeId:numericStoreId,fromDate:dateFrom,toDate:dateTo});
  const {data : ordersStats ,isLoading:ordersStatsLoading} = useStoreOrdersStatistics({filter:category,date:"",storeId:numericStoreId,fromDate:dateFrom,toDate:dateTo});
  const {data:products,isLoading:productsLoading} = useTopFourProductOrdered({filter:category,date:"",storeId:numericStoreId,fromDate:dateFrom,toDate:dateTo});
  const {data:analytics} = useStoreOrdersAnalytics({filter:category,date:"",storeId:numericStoreId,fromDate:dateFrom,toDate:dateTo});

  return (
    <Layout title={t("layout_titles.overview")} headline=''>
      <div className='flex items-start'>
        <CategoriesSection
          selectedCategory={category?category:""}
          categories={categories}
          buttonAddLinkPath={""}
          buttonLinkPath={""}
          buttonLabel=''
          showAdd={false}
          notShowAddButton
        />
        {/* Conditionally render the "Custom" button or the date input */}
        {/* {category !== 'specific' && (
          <button
            onClick={handleCustomClick}
             className={`flex-shrink-0 flex items-center gap-2 px-4 py-2 mt-2 rounded-[20px] font-medium whitespace-nowrap capitalize ${
              category==="specific" ? "bg-primaryButton text-white" : "bg-white shadow-md text-Black "
            }`}
          >
            {t('custom')}
          </button>
        )}
        {category === 'specific' && (
          <div className="flex items-center ml-2 space-x-3">
            <label htmlFor="custom-date" className="text-gray-700">{t('custom')}:</label>
            <input
              id="custom-date"
              type="date"
              onChange={(e)=>handleDateChange(e)}
              className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primaryButton"
            />
          </div>
        )} */}
      </div>
      <div className=' mb-6'>
        <StoreStatsSearchForm/>
      </div>
      <FirstSectionHeroLand 
      loading={financialsLoading}
      availableBalance={financials?.availableBalance} 
      totalCanceled={financials?.totalCanceled}
      totalRefunded={financials?.totalRefunded}
      totalEarning={financials?.totalEarning}
      />
      <SecondHeroSection
      cancelledCount={ordersStats?.cancelledCount}
      completedCount={ordersStats?.completedCount}
      scheduledCount={ordersStats?.scheduledCount}
      loading={ordersStatsLoading}
      />
      <div className="mt-8 grid grid-cols-12 gap-4">
        {/* takes 3 of 12 columns */}
        <div className="col-span-12  md:col-span-5 xl:col-span-3 flex flex-col space-y-2">
          <CircleProgress percentage={analytics?.customerRepeatRate} size={200} strokeWidth={15}/>
          <HalfCircleRed number={analytics?.averagePrepTime} size={200} strokeWidth={15}/>
        </div>

        {/* takes 9 of 12 columns */}
        <div className="col-span-12 md:col-span-7 xl:col-span-9">
          {products && <TopFourProductsOrdered products={products} />}
          <LoadingErrorState
          isLoading={productsLoading}
          isError={false}
          type="table"
          />
        </div>
      </div>

    </Layout>
  )
}
